import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getApiUrl } from '../../config/api';
import { Category } from '../types';

export function useCategories() {
  const { categoryId, subCategoryId } = useParams<{
    categoryId?: string;
    subCategoryId?: string;
  }>();

  const [categories, setCategories] = useState<Category[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoadingCategories(true);
        const response = await fetch(getApiUrl('/api/templates/v1.0.0/stats'));
        const result = await response.json();

        if (result.status === 'success' && Array.isArray(result.data)) {
          setCategories(result.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  // Auto-select category and subcategory from URL parameters
  useEffect(() => {
    if (categories.length > 0 && categoryId && subCategoryId) {
      const category = categories.find((c) => c.categoryId === categoryId);
      if (category) {
        setSelectedCategory(categoryId);
        const subcategory = category.subcategories.find(
          (s) => s.subCategoryId === subCategoryId
        );
        if (subcategory) {
          setSelectedSubcategory(subCategoryId);
        }
      }
    }
  }, [categories, categoryId, subCategoryId]);

  return {
    categories,
    loadingCategories,
    selectedCategory,
    selectedSubcategory,
    setCategories,
    setSelectedCategory,
    setSelectedSubcategory,
  };
}
